import {
  POST_CONTACT_US_FORM_REQUEST,
  POST_CONTACT_US_FORM_SUCCESS,
  POST_CONTACT_US_FORM_FAILURE,
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case POST_CONTACT_US_FORM_REQUEST:
      return { ...initialState, isLoading: true };
    case POST_CONTACT_US_FORM_SUCCESS:
      return { data: { ...action.payload }, isLoading: false, error: null };
    case POST_CONTACT_US_FORM_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};